<template>
  <el-dialog v-dialog-drag :title="title" :width="width" :visible="visible" :close-on-click-modal="false" @close="handleClose">
    <el-form :inline="true" style="margin-bottom: 20px">
      <el-form-item label="仓库：">
        <warehouse-select :value.sync="queryParam.WID" select_style="width:200px;" placeholder="请选择仓库" required />
      </el-form-item>
      <el-form-item label="类型：">
        <el-radio-group v-model="importType">
          <el-radio label="1">入库</el-radio>
          <el-radio label="2">出库</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="表格导入" name="tabXls">
        <div class="xls-import">
          <el-upload
            drag
            ref="uploadXls"
            accept=".xls,.xlxs"
            :data="uploadData"
            :auto-upload="false"
            :limit="1"
            :show-file-list="true"
            :action="xlsTabData.uploadUrl"
            :headers="xlsTabData.headers"
            :on-success="uploadXlsSuccess"
            :on-error="uploadXlsError"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text"> 将文件拖到此处，或<em>点击上传</em> </div>
            <div class="el-upload__tip" slot="tip">只能上传excel文件。</div>
          </el-upload>
          <div class="btn-wrap">
            <el-button type="success" size="small" :loading="xlsTabData.loading1" @click="handleDownXls">下载模板</el-button>
            <el-button type="primary" size="small" :loading="xlsTabData.loading2" @click="handleImportByXls">导入数据</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
import { baseURL, successCode } from '@/config'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
export default {
  name: 'storageImport',
  components: {
    WarehouseSelect,
  },
  data() {
    return {
      visible: false,
      width: '800px',
      title: '导入库存',
      activeTab: 'tabXls',
      importType: '1', // 入库/出库选项，默认入库
      queryParam: {
        WID: undefined, // 仓库ID
      },
      xlsTabData: {
        loading1: false,
        loading2: false,
        uploadUrl: `${baseURL}/api/wms/storageQuery/importStorageDetail`,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
        },
      },
      uploadData: {
        WID: '',
        ImportType: '',
      },
    }
  },
  methods: {
    async initDialog() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    async handleDownXls() {
      var a = document.createElement('a')
      a.href = '/static/Upload/出入库库存导入模板.xls'
      a.download = '出入库库存导入模板.xls'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },

    handleImportByXls() {
      this.uploadData.WID = this.queryParam.WID
      this.uploadData.ImportType = this.importType
      if (!this.queryParam.WID) {
        this.$message.error('请选择仓库')
        return
      }
      if (this.$refs.uploadXls.uploadFiles.length <= 0) {
        this.$message.error('请选择要上传的文件')
        return
      }
      this.xlsTabData.loading2 = true
      this.$refs.uploadXls.submit()
    },
    uploadXlsSuccess(res) {
      console.log(res)
      if (successCode.includes(res.code)) {
        this.handleClose()
        this.$alert(res.msg, '导入结果', {
          dangerouslyUseHTMLString: true,
        })
        this.$emit('handleQuery')
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        })
      }
      this.$refs.uploadXls.clearFiles()
      this.xlsTabData.loading2 = false
    },
    uploadXlsError() {
      this.$message({
        type: 'error',
        message: '导入失败',
      })
      this.xlsTabData.loading2 = false
    },
  },
}
</script>
<style scoped>
.xls-import {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.xls-import .btn-wrap {
  margin-top: 10px;
}
</style>
